import { Controller } from '@hotwired/stimulus';

// Scrolls the tabs card into view when clicking a tab.
// Prevents the page from jumping to the top.
//
// Usage:
//   <div data-controller="scroll-to-tabs">
//     <a data-action="click->scroll-to-tabs#scroll">Tab</a>
//   </div>
export default class extends Controller {
  scroll() {
    requestAnimationFrame(() => {
      this.element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  }
}
